export class ConnectionFactory {
  public static getPath(): string {
    return 'connections';
  }
}
